/* Cart drawer v2 (conversion test): one-tap "Complete the set" adds, with a Shopify-recommendations fallback */
(function () {
  'use strict';
  if (window.__cartV2) return;
  window.__cartV2 = true;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    try { if (typeof window.formatMoney === 'function') return window.formatMoney(cents, (window.theme && window.theme.moneyFormat) || '${{amount}}'); } catch (e) { /* noop */ }
    return '$' + (cents / 100).toFixed(2);
  }
  function abbr(s) {
    var m = { 'x-small': 'XS', 'small': 'S', 'medium': 'M', 'large': 'L', 'x-large': 'XL', 'xx-large': '2XL', 'xxl': '2XL', '2xl': '2XL', '3xl': '3XL', 'one size': 'OS' };
    var k = String(s || '').trim().toLowerCase();
    return m[k] || s;
  }
  function getDrawer() { return document.querySelector('cart-drawer'); }

  /* ---- add to cart from a suggestion */
  var adding = false;
  function add(item, btn) {
    if (adding) return;
    var picked = item.querySelector('[data-cart-upsell-size]:checked');
    var input = item.querySelector('[data-cart-upsell-variant]');
    var id = (picked && picked.value) || (input && (input.value || input.getAttribute('data-default')));
    if (!id) return;
    adding = true;
    btn.classList.add('is-loading');
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    var cart = getDrawer();
    var hasDrawer = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
    if (hasDrawer) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (!json || json.status) throw new Error((json && (json.description || json.message)) || 'cart-error');
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', productVariantId: id }); } catch (e) { /* noop */ } }
        if (hasDrawer && json.sections) {
          cart.classList.remove('is-empty');
          try { cart.renderContents(json); } catch (e) { if (window.console) console.error('[cart-v2] render failed', e); }
        }
      })
      .catch(function (err) {
        if (window.console) console.error('[cart-v2] add failed', err);
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setTimeout(function () { btn.classList.remove('is-error'); }, 2000);
      })
      .then(function () { adding = false; });
  }
  /* keep the hidden variant input in sync with the selected pill (and clear a stale "added" state) */
  document.addEventListener('change', function (e) {
    var pill = e.target.closest('[data-cart-upsell-size]');
    if (!pill) return;
    var item = pill.closest('[data-cart-upsell-item]');
    var input = item && item.querySelector('[data-cart-upsell-variant]');
    if (input) input.value = pill.value;
    var btn = item && item.querySelector('[data-cart-upsell-add]');
    if (btn) btn.classList.remove('is-added', 'is-error');
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('[data-cart-upsell-item]');
    if (item) add(item, btn);
  });

  /* ---- fallback: Shopify recommendations when no bundle / complementary metafields exist */
  function renderFallback(box) {
    if (!box || box.__loading) return;
    box.__loading = true;
    var pid = box.getAttribute('data-fallback-product-id');
    var inCart = (box.getAttribute('data-in-cart') || '').split(',').filter(Boolean);
    var cartSize = (box.getAttribute('data-cart-size') || '').toLowerCase();
    var limit = parseInt(box.getAttribute('data-limit') || '3', 10);
    if (!pid) { box.hidden = true; return; }
    var base = ((window.routes && window.routes.product_recommendations_url) || '/recommendations/products').replace(/\/$/, '');
    var url = base + '.json?product_id=' + encodeURIComponent(pid) + '&limit=8&intent=complementary';
    fetch(url).then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) return fetch(base + '.json?product_id=' + encodeURIComponent(pid) + '&limit=8&intent=related').then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (d2) { return (d2 && d2.products) || []; });
        return products;
      })
      .then(function (products) {
        var list = box.querySelector('[data-cart-upsell-list]');
        var picked = products.filter(function (p) { return p.available && inCart.indexOf(String(p.id)) === -1; }).slice(0, limit);
        if (!list || !picked.length) { box.hidden = true; return; }
        list.innerHTML = picked.map(function (p) {
          var sizeIdx = (p.options || []).findIndex(function (o) { return String(o.name || o).toLowerCase() === 'size'; });
          var optNames = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
          sizeIdx = optNames.findIndex(function (n) { return String(n).toLowerCase() === 'size'; });
          var control = '';
          var defaultId = (p.variants.find(function (v) { return v.available; }) || p.variants[0]).id;
          if (sizeIdx > -1) {
            var seen = {}; var order = [];
            p.variants.forEach(function (v) {
              var size = v['option' + (sizeIdx + 1)];
              if (seen[size]) { if (!seen[size].available && v.available) seen[size] = v; return; }
              seen[size] = v; order.push(size);
            });
            var chosen = null;
            order.forEach(function (size) { var v = seen[size]; if (v.available && size.toLowerCase() === cartSize) chosen = v.id; });
            if (chosen) defaultId = chosen;
            var group = 'cart-upsell-' + p.id; var pills = '';
            order.forEach(function (size, i) {
              var v = seen[size]; var pid = group + '-' + i;
              pills += v.available
                ? '<input type="radio" class="visually-hidden cart-upsell__radio" name="' + group + '" id="' + pid + '" value="' + v.id + '" data-cart-upsell-size data-size="' + esc(size) + '"' + (v.id === defaultId ? ' checked' : '') + '><label class="cart-upsell__pill" for="' + pid + '">' + esc(abbr(size)) + '</label>'
                : '<span class="cart-upsell__pill is-soldout" aria-disabled="true" title="' + esc(size) + ' - sold out">' + esc(abbr(size)) + '</span>';
            });
            control = '<input type="hidden" data-cart-upsell-variant value="' + defaultId + '"><fieldset class="cart-upsell__sizes" data-cart-upsell-sizes><legend class="visually-hidden">' + esc((window.cartV2Strings && window.cartV2Strings.size) || 'Size') + '</legend>' + pills + '</fieldset>';
          } else {
            control = '<input type="hidden" data-cart-upsell-variant value="' + defaultId + '">';
          }
          var img = p.featured_image ? '<img class="cart-upsell__img" src="' + esc(p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt="" loading="lazy">' : '';
          var price = money(p.price) + (p.compare_at_price && p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : '');
          return '<li class="cart-upsell__item" data-cart-upsell-item>' +
            '<a class="cart-upsell__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
            '<div class="cart-upsell__info"><a class="cart-upsell__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<div class="cart-upsell__price">' + price + '</div>' +
            '<div class="cart-upsell__row">' + control + '<button type="button" class="button button--primary cart-upsell__add" data-cart-upsell-add><span class="button-label">' + esc((window.cartV2Strings && window.cartV2Strings.add) || 'Add') + '</span></button></div></div></li>';
        }).join('');
        box.hidden = false;
      })
      .catch(function () { box.hidden = true; })
      .then(function () { box.__loading = false; });
  }
  function scan() {
    document.querySelectorAll('[data-cart-upsell][data-cart-upsell-empty]').forEach(renderFallback);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var drawer = getDrawer();
  if (drawer && window.MutationObserver) new MutationObserver(function () { scan(); }).observe(drawer, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scan);
})();
